// tslint:disable:no-any (autogenerated)
import BaseStore from '../../components/base/base-store';
import { runAllTests, IDetectedFeatures } from './device-features-detection';

export interface IDeviceFeaturesStore {
    features: IDetectedFeatures;
    loaded: boolean;
}

class DeviceFeaturesStore extends BaseStore<IDeviceFeaturesStore> {
    public dispatcherEvents: string = 'setDeviceFeaturesState';

    public initialState: any = {
        features: {},
        loaded: false
    };

    constructor() {
        super();
        this.initialize('DeviceFeaturesStore');
        this.detectFeatures();
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    async detectFeatures() {
        const features = await runAllTests();
        this.updateState({
            features,
            loaded: true
        });
    }
}

const store = new DeviceFeaturesStore();
// tslint:disable-next-line:no-default-export (autogenerated)
export default store;
